import { Directive, ElementRef, OnInit } from '@angular/core';
@Directive({
  standalone: true,
  selector: '[appFocus]',
})
export class FocusDirective implements OnInit {
  constructor(private _element: ElementRef) {}

  ngOnInit(): void {
    this._element.nativeElement.focus();
  }
}
